module.exports = __webpack_public_path__ + "static/media/icon-folder-minus.7eac2c4a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/elements/FileItem/assets/icon-folder-minus.svg
// module id = 2473
// module chunks = 193